import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

import { ROUTES } from '@/config/routes';

const OverviewPage = lazy(() =>
  import('./routes/OverviewPage').then((m) => ({ default: m.OverviewPage })),
);
const PlansPage = lazy(() => import('./routes/PlansPage').then((m) => ({ default: m.PlansPage })));
const PlanFormPage = lazy(() =>
  import('./routes/PlanFormPage').then((m) => ({ default: m.PlanFormPage })),
);
const RequestsPage = lazy(() =>
  import('./routes/RequestsPage').then((m) => ({ default: m.RequestsPage })),
);

/**
 * The platform operator's billing: an overview, the plan catalogue and its form, and the queue of
 * requests for a custom plan.
 *
 * <p>**Listed inside the `<SuperAdminRoute />` group in `app/router`**, which is what restricts it:
 * the guard applies to the group, so a screen added here is protected by where it is put. The
 * endpoints behind every screen are `@SuperAdminOnly` as well, and are what actually refuse anybody
 * else. `plans/new` comes before `plans/:planId` so it is not read as an id.
 *
 * <p>Not built, and why: the previous system also had a subscriptions list, payment methods,
 * billing and financial reports and usage analytics. The first has no endpoint here, the next three
 * were pages of figures typed into the source, and usage analytics likewise. They are not ported as
 * they were, because a revenue chart that does not move is a bug that looks like a feature.
 */
export const platformBillingRoutes: RouteObject[] = [
  { path: ROUTES.platformBilling, element: <OverviewPage /> },
  { path: ROUTES.platformBillingPlans, element: <PlansPage /> },
  { path: ROUTES.platformBillingPlanNew, element: <PlanFormPage /> },
  { path: ROUTES.platformBillingPlan, element: <PlanFormPage /> },
  { path: ROUTES.platformBillingRequests, element: <RequestsPage /> },
];
